import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

/** Logged-in app areas should not be indexed by search engines. */
export default function AppShellSeo() {
  const { pathname } = useLocation();
  if (!pathname.startsWith("/dashboard") && !pathname.startsWith("/system-admin")) {
    return null;
  }
  return (
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
  );
}
